import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useEditorWebsocket } from "@hooks";
import {
  useEstimateEditorSettings,
  ElementChatPopup,
  TimelineSettings, VisibilityButton, useEstimateEditorStore
} from "@tools";
import { TooltipIcon } from "@components";
import { Trash } from "@assets";

export const TimelineNestedRowActions = observer(({
  resource,
  parentUsesTimelinePercent,
}) => {
  const { t } = useTranslation();
  const { visibilityMode } = useEstimateEditorStore();
  const { allowEdition, showChatThread } = useEstimateEditorSettings();
  const socket = useEditorWebsocket();
  
  const { id, name, treePath, hideOnTimeline } = resource;
  
  const path = treePath.join("/");
  const timelinePath = "t" + path;

  const handleRemoval = async () => {
    resource.removeSelf();
    socket?.requestCommentPathRemove(path);
    socket?.requestCommentPathRemove(timelinePath);
  };

  return (
    <>
      {
        allowEdition &&
        <>
          <TooltipIcon
            icon={<Trash color="error" />}
            onClick={handleRemoval}
            className="button-remove hoverIcon"
          >
            {t("views.editor.remove_resource")}
          </TooltipIcon>
          {
            !parentUsesTimelinePercent &&
            <TimelineSettings
              fullSettings
              className="button-wta-settings hoverIcon opq"
              selectedResource={id}
            />
          }
        </>
      }
      {
        visibilityMode &&
        <VisibilityButton
          hidden={hideOnTimeline}
          onChange={resource.setHideOnTimeline}
          inRow
        />
      }
      {
        showChatThread &&
        <ElementChatPopup
          rowThread
          path={timelinePath}
          taskName={name || t("common.unnamed")}
        />
      }
    </>
  );
});

TimelineNestedRowActions.propTypes = {
  resource: object.isRequired,
  allowEdition: bool,
  showChatThread: bool,
  parentUsesTimelinePercent: bool,
};
